import React from "react";
import { CUSTOMER_SUMMARY_LOCK_MESSAGE } from "../../utils/lookupUtils";

export const SummaryLockIcon: React.FC<{ message?: string }> = ({
  message = CUSTOMER_SUMMARY_LOCK_MESSAGE,
}) => (
  <span className="summary-lock-badge" title={message} aria-label={message}>
    <span className="summary-lock-badge__rings" aria-hidden="true" />
    <svg
      className="relative w-3.5 h-3.5 shrink-0 text-white"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 2a5 5 0 00-5 5v3H6a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2h-1V7a5 5 0 00-5-5zm-3 8V7a3 3 0 016 0v3H9z" />
    </svg>
  </span>
);
